import React from 'react';

function QuizLanding(props) {
	return (
		<section className="landing-section">
			<img
				className="landing-section__img"
				src="https://cdn.filestackcontent.com/sLg2ekNOTvSWHbtQAZof"
				alt="CO-logo"
			/>
			<div className="landing-section__copy">
				<h1 className="landing-section__copy-heading">
					What is Your Risk Quotient?
				</h1>
				<p className="landing-section__copy-explanation">
					Your Risk Quotient number (R.Q.) tells you how you feel about money.
				</p>
				<p className="landing-section__copy-explanation">
					Are you a risk taker? Do you prefer a balanced approach, sometimes
					making a bet and sometimes playing it safe? Or do you prefer slow,
					steady growth, and no surprises?{' '}
				</p>
				<p className="landing-section__copy-explanation">
					There’s no wrong answer. But there is a concrete number we can use to
					tell you where you fall on the spectrum of risk.
				</p>
				<p className="landing-section__copy-cta">
					Answer these 12 questions to find out your R.Q. number!
				</p>
			</div>
			<button onClick={props.onClick} className="landing-section__button">
				<span className="landing-section__button-content">
					Let's Get Started
				</span>
			</button>
		</section>
	);
}
export default QuizLanding;



// WEBPACK FOOTER //
// ./src/components/quiz/QuizLanding.js